import React from "react";
import {
    AlertDialog,
    AlertDialogOverlay,
    AlertDialogContent,
    AlertDialogHeader,
    AlertDialogBody,
    AlertDialogFooter,
    Button,
} from "@chakra-ui/react";
import {useTranslation} from "react-i18next";

const ConfirmDeleteDialog = ({ isOpen, onClose, onConfirm, cancelRef, message }) => {
    const {t} = useTranslation();
    return (
        <AlertDialog isOpen={isOpen} leastDestructiveRef={cancelRef} onClose={onClose}>
            <AlertDialogOverlay>
                <AlertDialogContent>
                    <AlertDialogHeader fontSize="lg" fontWeight="bold">
                        {t("system.dialogs.delete.title")}
                    </AlertDialogHeader>

                    <AlertDialogBody>{message}</AlertDialogBody>

                    <AlertDialogFooter>
                        <Button ref={cancelRef} onClick={onClose}>
                            {t("system.dialogs.delete.buttons.cancel")}
                        </Button>
                        <Button colorScheme="red" onClick={onConfirm} ml={3}>
                            {t("system.dialogs.delete.buttons.confirm")}
                        </Button>
                    </AlertDialogFooter>
                </AlertDialogContent>
            </AlertDialogOverlay>
        </AlertDialog>
    );
};

export default ConfirmDeleteDialog;
